import { Component, ElementRef, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ContactDocumentService } from '../../service/data/contact-document.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ContactDocument } from '../../model/contact-document';
import { DocumentInformationNoteComponent } from '../../../core/component/information-note-base/document-information-note';

@Component({
    selector: 'app-contact-information-note',
    templateUrl: './../../../core/component/information-note/information-note.component.html',
    styleUrls: ['./../../../core/component/information-note/information-note.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactDocumentInformationNoteComponent extends DocumentInformationNoteComponent<ContactDocument> {
  @ViewChild('tooltip') tooltipBlock: ElementRef<HTMLInputElement>;
  @ViewChild('tooltipIcon') tooltipIcon: ElementRef<HTMLInputElement>;

  constructor(_renderer: Renderer2, contactDocumentService: ContactDocumentService, nativeWindow: NativeWindowService) {
    super(_renderer, contactDocumentService, nativeWindow);
  }

  isClickable = true;
}
